export const offerTemplate = {
    image_base64: '',
    text_en: 'We offer to you something gooooood',
    text_ukr: 'Пропонуємо тобі дещо дуже добре',
}
